import { Extension } from '@tiptap/core';
import { indentAttribute } from './Indent/indentAttribute';
import { indent, outdent } from './Indent/indentCommands';
import bodyEditorEngine from './BodyEditorEngine';

/**
 * IndentExtension — block-level indent via margin-left.
 * Handles paragraph, heading, bulletList and orderedList.
 */
const IndentExtension = Extension.create({
    name: 'indent',

    addGlobalAttributes() {
        return indentAttribute;
    },

    addCommands() {
        return { indent, outdent };
    },

    addKeyboardShortcuts() {
        return {
            Tab: () => this.editor.commands.indent(),
            'Shift-Tab': () => this.editor.commands.outdent(),
            'Mod-s': async (e, b, c) => {
                const html = this.editor.getHTML();
                await bodyEditorEngine.save(html);
            },
        };
    },
});

export default IndentExtension;
